import i18n from '@/plugins/i18n';
import { PERFORMANCE_BY_TIME } from '@/utils/constants';

const sizeRanges = [
  { min: 0, max: 10, size: 1 },
  { min: 11, max: 20, size: 10 },
  { min: 21, max: 30, size: 20 },
];

const getSizeForValue = (value) => {
  for (const range of sizeRanges) {
    if (value >= range.min && value <= range.max) {
      return range.size;
    }
  }
  return 5;
};

const createBubble = (subjectName, childrenData, nameToValueMap) => {
  const respondents = nameToValueMap[subjectName];
  if (childrenData.value !== 0) {
    return {
      name: subjectName,
      x: childrenData.hour,
      y: respondents,
      z: getSizeForValue(childrenData[PERFORMANCE_BY_TIME.TOTAL]),
      value: childrenData[PERFORMANCE_BY_TIME.TOTAL],
      opened_value: childrenData[PERFORMANCE_BY_TIME.OPENED],
      answered_value: childrenData[PERFORMANCE_BY_TIME.ANSWERED],
      waiting_value: childrenData[PERFORMANCE_BY_TIME.WAITING],
      closed_value: childrenData[PERFORMANCE_BY_TIME.CLOSED],
      ignored_value: childrenData[PERFORMANCE_BY_TIME.IGNORED],
      percentage: childrenData[PERFORMANCE_BY_TIME.PERCENTAGE],
      percentage_global: childrenData[PERFORMANCE_BY_TIME.PERCENTAGE_GLOBAL],
    };
  }
  return null;
};
let subjects = [];
export default {
  performanceByTime: {
    servicePath: 'PerformanceByTimeMatrix',
    series: ({ data }) => {
      if (!data) return [];
      subjects = data.map(subject => subject.name);
      const nameToValueMap = {};
      subjects.forEach((name, index) => {
        nameToValueMap[name] = index;
      });

      return data.map(subject => {
        const seriesData = subject.children.map(childrenData => createBubble(subject.name, childrenData, nameToValueMap));
        return {
          name: subject.name,
          data: seriesData,
        };
      });
    },
    getTooltipHTML: (point) => {
      return `
        <span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.name')}: <b>${point.name}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.hour')}: <b>${point.x}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.value')}: <b>${point.value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.opened')}: <b>${point.opened_value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.answered')}: <b>${point.answered_value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.waiting')}: <b>${point.waiting_value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.closed')}: <b>${point.closed_value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.ignored')}: <b>${point.ignored_value}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.percentage')}: <b>${point.percentage}</b></span>
          <span style="display: block;">${i18n.t('components.PerformanceByTimeMatrix.label.bubble.percentageGlobal')}: <b>${point.percentage_global}</b></span>
        </span>
      `;
    },
  },
};
